import server from './server'

export const searchTicketAccessCode = (accessCode) => {
  return server.get(`/ticket_access_codes/${accessCode}`)
}
